import { VStack, HStack } from "@chakra-ui/layout";
import { FormControl, FormErrorMessage, FormLabel } from "@chakra-ui/react";
import { UseFormRegister, FieldErrors, FieldValues, UseFormTrigger } from "react-hook-form";
import { ChangeEvent } from "react";

import { CorporationIdentifiersDictionary } from "doxecure-commons/doxecureTypes";
import { $length, $ok } from "foundation-ts/commons";

import { CorporationForm } from "@/components/CorporationForm/CorporationForm";
import { G1Input } from "@components/G1Input";
import { RegisterFormValues } from "./SignupTypes";

interface AccountStepProps {
    // isAloneUser: Nullable<boolean>;
    corporationIdentifiersDict: CorporationIdentifiersDictionary;
    countries: any;
    isSearchInProgress: boolean;
    data?: {
        lastname?: string;
        firstname?: string;
        email?: string;
        organizationName?: string;
        organizationIdentifier?: string;
        city?: string;
    };
    errors: FieldErrors<RegisterFormValues>;
    register: UseFormRegister<FieldValues>;
    trigger: UseFormTrigger<FieldValues>;
    onCorporationChange: (e: any) => void;
    onCorporationIdentifierChange: (e: ChangeEvent<HTMLInputElement>) => void;
    onCountryChange: (e: ChangeEvent<HTMLSelectElement>) => void;
    validateCorporationIdentifier: (id: string) => boolean;
}

export default function AccountStep(props: AccountStepProps) {
    const {
        data,
        // isAloneUser,
        corporationIdentifiersDict,
        countries,
        isSearchInProgress,
        errors,
        register,
        trigger,
        onCorporationChange,
        onCorporationIdentifierChange,
        onCountryChange,
        validateCorporationIdentifier
    } = props;

    return (
        <form>
            <VStack>
                <HStack width="100%" align="flex-start">
                    <FormControl isRequired isInvalid={$ok(errors.lastname)}>
                        <FormLabel fontSize="1.25em">Nom</FormLabel>
                        <G1Input id="lastname" name="lastname" component="connection.form" autoFocus textTransform="uppercase"
                                 registerInput={{ ...register("lastname", { required: true, pattern: /^[a-zàâäéèêëïîôöùûüç]+([ '-][a-zàâäéèêëïîôöùûüç]+)*$/i }) }} />
                        <FormErrorMessage color="red.200">Le nom de l'utilisateur est {$length(data?.lastname) === 0 ? "requis" : "invalide"}</FormErrorMessage>
                    </FormControl>
                    <FormControl isRequired isInvalid={$ok(errors.firstname)}>
                        <FormLabel fontSize="1.25em">Prénom</FormLabel>
                        <G1Input id="firstname" name="firstname" component="connection.form" textTransform="capitalize"
                                 registerInput={{ ...register("firstname", { required: true, pattern: /^[a-zàâäéèêëïîôöùûüç]+([ '-][a-zàâäéèêëïîôöùûüç]+)*$/i }) }} />
                        <FormErrorMessage color="red.200">Le prénom de l'utilisateur est {$length(data?.firstname) === 0 ? "requis" : "invalide"}</FormErrorMessage>
                    </FormControl>
                </HStack>
                <FormControl isRequired isInvalid={$ok(errors.email)}>
                    <FormLabel fontSize="1.25em">Adresse mail</FormLabel>
                    <G1Input id="email" name="email" type="email" component="connection.form" placeholder="test@test.com" textTransform="lowercase"
                             registerInput={{ ...register("email", { required: true, pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i }) }} />
                    <FormErrorMessage color="red.200">L'adresse mail est {$length(data?.email) === 0 ? "requise" : "invalide"}</FormErrorMessage>
                </FormControl>
                <CorporationForm
                    label="Organisation" // {isAloneUser ? "Entreprise" : "Organisation"}
                    component="connection.form"
                    required
                    showUniqueId
                    isSearchInProgress={isSearchInProgress}
                    countries={countries}
                    corporationIdentifiersDict={corporationIdentifiersDict}
                    data={{
                        organizationName: data?.organizationName,
                        organizationIdentifier: data?.organizationIdentifier,
                        city: data?.city
                    }}
                    errors={errors}
                    register={register}
                    trigger={trigger}
                    onChange={onCorporationChange}
                    onCorporationIdentifierChange={onCorporationIdentifierChange}
                    onCountryChange={onCountryChange}
                    validate={validateCorporationIdentifier}
                />
            </VStack>
        </form>
    );
}